<template>
  <div>
    <div v-if="error" class="error" v-html="error"></div>

    <div class="loading" v-if="loading">
      <div class="wrapper">
        <span class="spinner"></span>
        <p class="sr-only">Loading...</p>
      </div>
    </div>

    <div v-else-if="page" class="resources-page">

      <header class="resources-page--header">
        <div class="wrapper">
          <div class="resource-header--title">
            <h1 v-html="page.title.rendered"></h1>
          </div>
        </div>
      </header>

      <div class="wrapper resources-page--content" v-html="page.content.rendered"></div>

      <div class="wrapper resources-page--resource-list" :class="{'resources-page--resource-list__single': $route.params.slug }" v-if="resourcesShown">
        <ResourceCard
          v-for="resource in resourcesShown"
          :key="resource.name.toLowerCase().replace(/ /g, '-')"
          :resource="resource"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ResourceCard from '@/components/ResourceCard'

export default {
  name: 'ResourcesPage',
  components: {
    ResourceCard,
  },
  data() {
    return {
      recaptcha: {
        site_key: '6LfvMaspAAAAAHMgxWpxqfdlAeYUYUPfyTg8mGhD'
      },
      recaptchaVerified: false,
      hasFormErrors: false,
      formFeedback: '',
      loading: true,
      submitting: false,
      page: false
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
    error() {
      return this.$store.getters.getError
    },
    isMember() {
      return this.$store.getters.isMember
    },
    resourcesShown() {
      if (this.page && this.page.acf.resources && this.page.acf.resources) {
        return this.page.acf.resources.filter(resource => {
          if (this.$route.params.slug) {
            return resource.name.toLowerCase().replace(/ /g, '-') === this.$route.params.slug && (resource.restriction ? this.user.roles.includes(resource.restriction) || this.user.roles.includes('administrator') : true)
          }
          return this.user.roles.includes(resource.restriction) || !resource.restriction || this.user.roles.includes('administrator');
        });
      }
      return [];
    },
    // form() {
    //   const html = this.page.acf.form_shortcode;
    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(html, 'text/html');
    //   const form = doc.querySelector('form');
    //   const formFooter = form.querySelector('.form-footer');
    //   if (formFooter) {
    //     formFooter.remove();
    //   }
    //   const innerContents = form.innerHTML;
    //   return innerContents;
    // },
  },
  mounted() {
    const slug = 'resources';
    this.$store.dispatch('getPage', slug).then(() => {
      this.page = this.$store.getters.getPage(slug)
      // setTimeout(() => this.formInit(), 1000)
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    // onVerify(response) {
    //   if (response) this.recaptchaVerified = true;
    // },
    // formInit() {
    //   const expertiseSelect = document.querySelectorAll('#expertise input[type=checkbox]');
    //   expertiseSelect.forEach(checkbox => {
    //     checkbox.addEventListener('change', () => {
    //       const checked = document.querySelectorAll('#expertise input[type=checkbox]:checked');
    //       let containsOther = false;
    //       for (let checkedOption of checked) {
    //         if (checkedOption.value === 'Other') {
    //           containsOther = true;
    //           document.querySelector('.if-other').style.display = 'block';
    //           return;
    //         }
    //       }
    //       if (!containsOther) {
    //         document.querySelector('.if-other').style.display = 'none';
    //       }
    //     });
    //   });
    //
    // },
    //
    // submitForm() {
    //   if (this.submitting) return
    //   this.submitting = true
    //   this.formFeedback = ''
    //   this.hasFormErrors = false
    //   const form = document.querySelector('.form');
    //   const errorMessages = document.querySelectorAll('.error-message');
    //   errorMessages.forEach(errorMessage => {
    //     errorMessage.remove();
    //   });
    //   const formElements = form.querySelectorAll('input, select, textarea');
    //
    //   if (!this.recaptchaVerified) {
    //     this.hasFormErrors = true
    //     this.formFeedback = 'Please verify that you are not a robot.'
    //     this.submitting = false
    //     return
    //   }
    //
    //   formElements.forEach(element => {
    //     if (element.classList.contains('wpcf7-validates-as-required') && element.value.trim() === '') {
    //       const formGroup = element.closest('.form-group');
    //       const errorMessage = document.createElement('div');
    //       errorMessage.classList.add('error-message');
    //       errorMessage.textContent = 'This field is required.';
    //       formGroup.appendChild(errorMessage);
    //       this.hasFormErrors = true
    //     }
    //     if (element.classList.contains('wpcf7-validates-as-email') && !/\S+@\S+\.\S+/.test(element.value)) {
    //       const formGroup = element.closest('.form-group');
    //       const errorMessage = document.createElement('div');
    //       errorMessage.classList.add('error-message');
    //       errorMessage.textContent = 'Please enter a valid email address.';
    //       formGroup.appendChild(errorMessage);
    //       this.hasFormErrors = true
    //     }
    //   });
    //
    //   if (!this.hasFormErrors) {
    //     var bodyFormData = new FormData();
    //     formElements.forEach(element => {
    //       if (element.type === 'checkbox' || element.type === 'radio') {
    //         if (element.checked) {
    //           bodyFormData.append(element.name, element.value);
    //         }
    //       } else if (element.type === 'file') {
    //         const files = element.files;
    //         for (let i = 0; i < files.length; i++) {
    //           bodyFormData.append(element.name, files[i]);
    //         }
    //       } else {
    //         if (element.value) {
    //           bodyFormData.append(element.name, element.value);
    //         }
    //       }
    //     });
    //     this.$store.dispatch('submitForm', {
    //       formID: this.page.acf.form,
    //       formData: bodyFormData
    //     }).then((valid) => {
    //       if (valid) {
    //         formElements.forEach(element => {
    //           if (element.classList.contains('wpcf7-text')) {
    //             element.value = '';
    //           }
    //         });
    //         this.submitting = false
    //         this.formFeedback = 'Thank you for your message.'
    //       }
    //     });
    //   } else {
    //     this.submitting = false
    //   }
    // },
  },
  metaInfo() {
    return {
      title: this.page ? (this.page.acf.hero_title ? this.page.acf.hero_title : this.page.title.rendered) : 'Resources'
    }
  }
}

</script>
